import React from 'react';
import { KEMYCARD_LAUNCH } from '@pay888/shared';

export const ProviderAvailability: React.FC = () => (
  <section className="panel" aria-label="KemyCard connection status">
    <span className="eyebrow">KEMYCARD / CONNECTION IN PROGRESS</span>
    <h2>Preparing your card services</h2>
    <p className="muted">
      KemyCard is the selected card provider. Cards and funding are not live yet. Your funds will
      not be collected until secure access, eligibility and final fees are verified.
    </p>
    <div className="simple-row">
      <span>Current rollout</span>
      <strong>{KEMYCARD_LAUNCH.plan}</strong>
    </div>
    <div className="simple-row">
      <span>Payments and deposits</span>
      <strong>Not enabled</strong>
    </div>
    <p className="small-print">
      Identity checks and mobile wallet support depend on the card product.
    </p>
  </section>
);

export const UnavailableProviderFeature: React.FC = () => (
  <section className="panel" role="note">
    <h1>Service temporarily disabled</h1>
    <p>Payment links and card-payment collection are not part of the current KemyCard rollout.</p>
    <p className="muted">Existing records are preserved. No payment can be collected here.</p>
  </section>
);
